<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden p-6">
            <span class="h2 font-bold mb-8">Applicant Details</span>
            <div class="flex flex-wrap -mb-8 mt-8 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/6">

                    <div class="photo-container">
                        <img
                            src="https://fastly.picsum.photos/id/581/200/300.jpg?hmac=Xsg_aDXsNDPBGUvQPMKuMn2f4XS6zkrgh0vnl2lzljk"
                            alt="Photo"
                        >
                    </div>
                </div>

                <div class="flex flex-wrap pb-8 pr-6 w-full lg:w-10/12">
                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Name: &nbsp;</div>
                            <div class="value">{{ applicant.salutation + ' ' + applicant.name }}
                            </div>
                        </div>
                    </div>
                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Application Date: &nbsp;</div>
                            <div class="value">{{ applicant.application_date }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Application status: &nbsp;</div>
                            <div class="value">{{ applicant.status }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Contact number: &nbsp;</div>
                            <div class="value">{{ applicant.contact_number }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Alternative Contact Number: &nbsp;</div>
                            <div class="value">{{ applicant.contact_number }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">WhatsApp Number: &nbsp;</div>
                            <div class="value">{{ applicant.contact_number }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Home Contact Number: &nbsp;</div>
                            <div class="value">{{ applicant.contact_number }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-2/3">
                        <div class="info-row">
                            <div class="label">Email: &nbsp;</div>
                            <div class="value">{{ applicant.email }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Date of birth: &nbsp;</div>
                            <div class="value">{{ applicant.date_of_birth }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Marital status: &nbsp;</div>
                            <div class="value">{{ applicant.marital_status }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Gender: &nbsp;</div>
                            <div class="value">{{ applicant.gender }}
                            </div>
                        </div>
                    </div>


                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Pan number: &nbsp;</div>
                            <div class="value">{{ applicant.pan_number }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-2/3">
                        <div class="info-row">
                            <div class="label">Aadhaar number: &nbsp;</div>
                            <div class="value">{{ applicant.aadhaar_number }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/3">
                        <div class="info-row">
                            <div class="label">Category: &nbsp;</div>
                            <div class="value">{{ applicant.category }}</div>
                        </div>
                    </div>

                    <div class="w-full lg:w-2/3">
                        <div class="info-row">
                            <div class="label">If other: &nbsp;</div>
                            <div class="value">{{ applicant.other_category }}</div>
                        </div>
                    </div>


                    <div class="w-full lg:w-1/2">
                        <div class="info-row">
                            <div class="label">Current address: &nbsp;</div>
                            <div class="value">{{ applicant.current_address }}
                            </div>
                        </div>
                    </div>

                    <div class="w-full lg:w-1/2">
                        <div class="info-row">
                            <div class="label">Permanent address: &nbsp;</div>
                            <div class="value">{{ applicant.permanent_address }}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="mb-4">
                <hr/>
            </div>


            <span class="h2 font-bold mb-8">Family Details</span>
            <div class="flex flex-wrap -mb-8 mt-8 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/4">
                    <div class="photo-container">
                        <img
                            src="https://fastly.picsum.photos/id/581/200/300.jpg?hmac=Xsg_aDXsNDPBGUvQPMKuMn2f4XS6zkrgh0vnl2lzljk"
                            alt="Photo"
                        >
                    </div>
                    <div class="info-row">
                        <div class="label">Father: &nbsp;</div>
                        <div class="value">{{ applicant.father_name }}
                        </div>
                    </div>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-1/4">
                    <div class="photo-container">
                        <img
                            src="https://fastly.picsum.photos/id/581/200/300.jpg?hmac=Xsg_aDXsNDPBGUvQPMKuMn2f4XS6zkrgh0vnl2lzljk"
                            alt="Photo"
                        >
                    </div>
                    <div class="info-row">
                        <div class="label">Mother: &nbsp;</div>
                        <div class="value">{{ applicant.mohter_name }}
                        </div>
                    </div>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-1/4">
                    <div class="photo-container">
                        <img
                            src="https://fastly.picsum.photos/id/581/200/300.jpg?hmac=Xsg_aDXsNDPBGUvQPMKuMn2f4XS6zkrgh0vnl2lzljk"
                            alt="Photo"
                        >
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">Spouse: &nbsp;</div>
                        <div class="value">{{ applicant.spouse_name }}
                        </div>
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">Occupation: &nbsp;</div>
                        <div class="value">{{ applicant.spouse_occupation }}
                        </div>
                    </div>
                </div>
            </div>


            <span class="h2 font-bold mb-8">Children Details</span>
            <div class="flex flex-wrap -mb-8 mt-8 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/4">
                    <div class="photo-container">
                        <img
                            src="https://fastly.picsum.photos/id/581/200/300.jpg?hmac=Xsg_aDXsNDPBGUvQPMKuMn2f4XS6zkrgh0vnl2lzljk"
                            alt="Photo"
                        >
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">Name: &nbsp;</div>
                        <div class="value">{{ applicant.father_name }}
                        </div>
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">Class: &nbsp;</div>
                        <div class="value">{{ applicant.father_name }}
                        </div>
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">School name: &nbsp;</div>
                        <div class="value">{{ applicant.father_name }}
                        </div>
                    </div>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-1/4">
                    <div class="photo-container">
                        <img
                            src="https://fastly.picsum.photos/id/581/200/300.jpg?hmac=Xsg_aDXsNDPBGUvQPMKuMn2f4XS6zkrgh0vnl2lzljk"
                            alt="Photo"
                        >
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">Name: &nbsp;</div>
                        <div class="value">{{ applicant.father_name }}
                        </div>
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">Class: &nbsp;</div>
                        <div class="value">{{ applicant.father_name }}
                        </div>
                    </div>
                    <div class="info-row" style="display: -webkit-box">
                        <div class="label">School name: &nbsp;</div>
                        <div class="value">{{ applicant.father_name }}
                        </div>
                    </div>
                </div>
            </div>


            <div class="mb-4">
                <hr/>
            </div>

            <span class="h2 font-bold mb-8">Employment Details</span>
            <div class="flex flex-wrap mb-4 mt-8 -mr-6">
                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Joining Date: &nbsp;</div>
                        <div class="value">{{ applicant.joining_date }}
                        </div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Employee No.: &nbsp;</div>
                        <div class="value">{{ applicant.employee_no }}
                        </div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">User id: &nbsp;</div>
                        <div class="value">{{ applicant.user_id }}</div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Employment Type: &nbsp;</div>
                        <div class="value">{{ applicant.employment_type }}
                        </div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Designation: &nbsp;</div>
                        <div class="value">{{ applicant.designation }}
                        </div>
                    </div>
                </div>
                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Responsibility: &nbsp;</div>
                        <div class="value">{{ applicant.responsibility }}
                        </div>
                    </div>
                </div>
                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Duty: &nbsp;</div>
                        <div class="value">{{ applicant.duty }}
                        </div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Teaching Class(es): &nbsp;</div>
                        <div class="value">{{ applicant.teaching_classes }}
                        </div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Teaching Subject(s): &nbsp;</div>
                        <div class="value">{{ applicant.teaching_subjects }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-4">
                <hr/>
            </div>


            <span class="h2 font-bold mb-8">Bank Details</span>
            <div class="flex flex-wrap -mb-8 mt-8 -mr-6">
                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Bank Name & Branch: &nbsp;</div>
                        <div class="value">{{ applicant.bank_name_branch }}
                        </div>
                    </div>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Bank Account Number: &nbsp;</div>
                        <div class="value">{{ applicant.bank_account_number }}
                        </div>
                    </div>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">
                            IFSC Code: &nbsp;
                        </div>
                        <div class="value">{{ applicant.ifsc_code }}
                        </div>
                    </div>
                </div>
            </div>


            <div class="mb-4">
                <hr/>
            </div>


            <span class="h2 font-bold mb-8">Education Details</span>
            <div class="flex flex-wrap mb-4 mt-8 -mr-6">
                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">School name: &nbsp;</div>
                        <div class="value">{{ applicant.school_name }}
                        </div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Schooling medium: &nbsp;</div>
                        <div class="value">{{ applicant.schooling_medium }}
                        </div>
                    </div>
                </div>

                <div class="mb-2 w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Qualification / Degree: &nbsp;</div>
                        <div class="value">{{ applicant.department }}</div>
                    </div>
                </div>

                <div class="w-full lg:w-1/3">
                    <div class="info-row">
                        <div class="label">
                            Favourite Subjects: &nbsp;
                        </div>
                        <div class="value">{{ applicant.favourite_subjects }}
                        </div>
                    </div>
                </div>

                <div class="w-full">
                    <table class="tbl_qualification">
                        <thead>
                        <tr>
                            <th>STD</th>
                            <th>Year of Passing</th>
                            <th>Roll No.</th>
                            <th>University / Board / College</th>
                            <th>Subject(s)</th>
                            <th>Percentage/Division</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="qualification in applicant.academic_qualifications" :key="qualification.id">
                            <td>{{ qualification.std }}</td>
                            <td>{{ qualification.year_of_passing }}</td>
                            <td>{{ qualification.roll_no }}</td>
                            <td>{{ qualification.university }}</td>
                            <td>{{ qualification.subjects }}</td>
                            <td>{{ qualification.percentage }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>


            <div class="mb-4">
                <hr/>
            </div>


            <span class="h2 font-bold mb-8">Training Details</span>
            <div class="flex flex-wrap mt-8 -mr-6">
                <div class="w-full  mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Training Required: &nbsp;</div>
                        <div class="value">{{ applicant.training_required }}
                        </div>
                    </div>
                </div>

                <div class="w-full  mb-2 lg:w-2/3">
                    <div class="info-row">
                        <div class="label">Trainer Employee: &nbsp;</div>
                        <div class="value">{{ applicant.staff_trainer ?? '' }}
                        </div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">
                            From Date: &nbsp;
                        </div>
                        <div class="value">{{ applicant.training_from_date }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">
                            To Date: &nbsp;
                        </div>
                        <div class="value">{{ applicant.training_to_date }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">
                            Remark by Admin: &nbsp;
                        </div>
                        <div class="value">{{ applicant.remark_by_admin }}
                        </div>
                    </div>
                </div>


                <div class="w-full  mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Training start date: &nbsp;</div>
                        <div class="value">{{ applicant.training_required }}
                        </div>
                    </div>
                </div>

                <div class="w-full  mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Is training complete: &nbsp;</div>
                        <div class="value">{{ applicant.staff_trainer ?? '' }}
                        </div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Completion date: &nbsp;</div>
                        <div class="value">{{ applicant.training_to_date }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Positive points: &nbsp;</div>
                        <div class="value">{{ applicant.positive_points_by_trainer }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Negative points: &nbsp;</div>
                        <div class="value">{{ applicant.negative_points_by_trainer }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Suggestions: &nbsp;</div>
                        <div class="value">{{ applicant.remark_by_admin }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Issue articles : &nbsp;</div>
                        <div class="value">{{ applicant.remark_by_admin }}
                        </div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Remark: &nbsp;</div>
                        <div class="value">{{ applicant.trainer_remarks }}
                        </div>
                    </div>
                </div>

            </div>


            <div class="mb-4">
                <hr/>
            </div>


            <span class="h2 font-bold mb-8">Other Details</span>
            <div class="flex flex-wrap mt-8 -mr-6">

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Up to which class can you teach?: &nbsp;</div>
                        <div class="value">{{ applicant.teaching_class_limit }}</div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Creative brain academy joining reason?: &nbsp;</div>
                        <div class="value">{{ applicant.reason_to_join }}</div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="">
                        <div class="label">What do you know about Creative Brain Academy?: &nbsp;</div>
                        <div class="value">{{ applicant.about_academy }}</div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="">
                        <div class="label">Why do you prefer teaching job?: &nbsp;</div>
                        <div class="value">{{ applicant.prefer_teaching_reason }}</div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Your Positive Points: &nbsp;</div>
                        <div class="value">{{ applicant.positive_points }}</div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Your Negative Points: &nbsp;</div>
                        <div class="value">{{ applicant.negative_points }}</div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Previous work experience: &nbsp;</div>
                        <div class="value">{{ applicant.previous_work_experience }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Why did you leave the previous job?: &nbsp;</div>
                        <div class="value">{{ applicant.leave_reason }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Salary expectation: &nbsp;</div>
                        <div class="value">{{ applicant.salary_expectation }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">How long will you continue in our school?: &nbsp;</div>
                        <div class="value">{{ applicant.continue_duration }}
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Other Qualities: &nbsp;</div>
                        <div class="value">{{ applicant.other_qualities}}
                        </div>
                    </div>
                </div>

                <div class="w-full mb-2 lg:w-1/3">
                    <div class="">
                        <div class="label">Your full and final commitments & promises to our school and students: &nbsp;
                        </div>
                        <div class="value">{{ applicant.commitments }}
                        </div>
                    </div>
                </div>



                <div class="w-full  mb-2 lg:w-1/3">
                    <div class="info-row">
                        <div class="label">Other skills: &nbsp;</div>
                        <div class="value">{{ applicant.other_skills }}
                        </div>
                    </div>
                </div>

                <div class="w-full  mb-2 lg:w-2/3">
                    <div class="info-row">
                        <div class="label">Holiday list: &nbsp;</div>
                        <div class="value">{{ applicant.holiday_list ?? '' }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import AcademicQualifications from '@/Pages/Interview/AcademicQualifications'
import axios from 'axios'
import moment from 'moment'
import {QuillEditor} from '@vueup/vue-quill'
import Icon from '@/Shared/Icon'
import Loader from '@/Shared/Loader'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import 'moment-duration-format'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'

const FilePond = vueFilePond()
export default {

    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        AcademicQualifications,
        QuillEditor,
        Icon,
        Loader, Datepicker, FilePond,
    },
    layout: Layout,
    props: {
        applicant: Object,
    },
    data() {
        return {}
    },
    computed: {},
    methods: {},
    created() {
        this.moment = moment
    },

}
</script>
